<template>
  <el-dialog
    v-model="localVisible"
    title="Duplicar Especificación Técnica"
    width="450px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div style="font-size: 15px; margin-bottom: 10px; line-height: 1.5">
      Se duplicará la Especificación Técnica Nro <b>{{ codigoET }}</b
      >.<br />
    </div>

    <div style="font-size: 15px; font-weight: 500; margin-bottom: 20px">¿Desea continuar?</div>

    <template #footer>
      <el-button
        size="default"
        @click="localVisible = false"
      >
        Cancelar
      </el-button>
      <el-button
        type="primary"
        size="default"
        @click="onConfirm"
      >
        Duplicar
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  codigoET: { type: [Number, String], required: true },
});

const emit = defineEmits(['update:modelValue', 'confirm']);

const localVisible = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v),
});

const onConfirm = () => {
  emit('confirm', {
    codigoET: props.codigoET,
  });
};
</script>
